export const financialCategories = [
  "Audited Financial Statements",
  "Annual Financial Reports",
  "Budget Performance Reports",
  "Expenditure Reports",
  "Revenue Reports",
  "Appropriation Reports",
  "Financial Disclosure Reports",
  "Audit Reports",
  "Procurement Financial Summaries",
  "Project Financial Reports",
  "Grants and Intervention Fund Reports",
  "Statutory Financial Returns",
  "Management Financial Reports",
  "Other Approved Financial Records",
];

export const financialRecords = [
  {
    id: 1,
    title: "OGFZA Budget Performance Report Q2 2026",
    category: "Budget Performance Reports",
    reportingPeriod: "April to June 2026",
    financialYear: "2026",
    datePublished: "15 July 2026",
    fileFormat: "PDF",
    version: "1.0",
    status: "Published",
    approvingDepartment: "Finance and Accounts Department",
    fileName: "OGFZA-Budget-Performance-Report-Q2-2026.pdf",
    description:
      "Approved budget performance report covering the second quarter of the 2026 financial year.",
  },
  {
    id: 2,
    title: "OGFZA Budget Performance Report Q1 2026",
    category: "Budget Performance Reports",
    reportingPeriod: "January to March 2026",
    financialYear: "2026",
    datePublished: "15 April 2026",
    fileFormat: "PDF",
    version: "1.0",
    status: "Published",
    approvingDepartment: "Finance and Accounts Department",
    fileName: "OGFZA-Budget-Performance-Report-Q1-2026.pdf",
    description:
      "Approved budget performance report covering the first quarter of the 2026 financial year.",
  },
  {
    id: 3,
    title: "OGFZA Annual Financial Report 2025",
    category: "Annual Financial Reports",
    reportingPeriod: "January to December 2025",
    financialYear: "2025",
    datePublished: "28 February 2026",
    fileFormat: "PDF",
    version: "1.0",
    status: "Published",
    approvingDepartment: "Finance and Accounts Department",
    fileName: "OGFZA-Annual-Financial-Report-2025.pdf",
    description:
      "Annual financial report containing approved institutional financial information for the 2025 financial year.",
  },
  {
    id: 4,
    title: "OGFZA Revenue Report 2025",
    category: "Revenue Reports",
    reportingPeriod: "January to December 2025",
    financialYear: "2025",
    datePublished: "20 February 2026",
    fileFormat: "PDF",
    version: "1.0",
    status: "Published",
    approvingDepartment: "Finance and Accounts Department",
    fileName: "OGFZA-Revenue-Report-2025.pdf",
    description:
      "Approved revenue report showing financial inflows and revenue performance for the 2025 financial year.",
  },
  {
    id: 5,
    title: "OGFZA Expenditure Report 2025",
    category: "Expenditure Reports",
    reportingPeriod: "January to December 2025",
    financialYear: "2025",
    datePublished: "20 February 2026",
    fileFormat: "PDF",
    version: "1.0",
    status: "Published",
    approvingDepartment: "Finance and Accounts Department",
    fileName: "OGFZA-Expenditure-Report-2025.pdf",
    description:
      "Approved expenditure report showing institutional spending records for the 2025 financial year.",
  },
  {
    id: 6,
    title: "OGFZA Audited Financial Statement 2024",
    category: "Audited Financial Statements",
    reportingPeriod: "January to December 2024",
    financialYear: "2024",
    datePublished: "30 September 2025",
    fileFormat: "PDF",
    version: "1.0",
    status: "Published",
    approvingDepartment: "Internal Audit / Finance and Accounts Department",
    fileName: "OGFZA-Audited-Financial-Statement-2024.pdf",
    description:
      "Audited financial statement approved for public access and stakeholder reference.",
  },
  {
    id: 7,
    title: "OGFZA Procurement Financial Summary 2025",
    category: "Procurement Financial Summaries",
    reportingPeriod: "January to December 2025",
    financialYear: "2025",
    datePublished: "12 March 2026",
    fileFormat: "PDF",
    version: "1.0",
    status: "Published",
    approvingDepartment: "Procurement Department",
    fileName: "OGFZA-Procurement-Financial-Summary-2025.pdf",
    description:
      "Summary of approved procurement-related financial records for public information.",
  },
  {
    id: 8,
    title: "OGFZA Project Financial Report 2026",
    category: "Project Financial Reports",
    reportingPeriod: "January to June 2026",
    financialYear: "2026",
    datePublished: "30 July 2026",
    fileFormat: "PDF",
    version: "1.0",
    status: "Published",
    approvingDepartment: "Projects / Finance and Accounts Department",
    fileName: "OGFZA-Project-Financial-Report-2026.pdf",
    description:
      "Approved financial report for selected institutional projects and related expenditure summaries.",
  },
];